import React from "react";
import { useConsumerStore } from "../../../store";

function useAuthenticated() {
  const token = useConsumerStore((state) => state.token);
  return React.useMemo(() => !!token, [token]);
}

export default useAuthenticated;
